import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconLogout, IconRefresh } from '../../icons';
import Button from '../core/Button';
import { useLogout } from '../../hooks/useLogout';

interface SplashMessageProps {
  message: string;
  /** Renders a reload button for transient failures where logging out
   * (destroying the Kratos session) would be the wrong remedy. */
  onRetry?: () => void;
  onSwitchProfile?: () => void;
}

const SplashAction: React.FC<{
  icon: React.ReactNode;
  label: React.ReactNode;
  onClick: () => void;
}> = ({ icon, label, onClick }) => (
  <Button variant="ghost" startIcon={icon} onClick={onClick}>
    {label}
  </Button>
);

const SplashMessage: React.FC<SplashMessageProps> = ({
  message,
  onRetry,
  onSwitchProfile,
}) => {
  const performLogout = useLogout();

  return (
    <div className="flex h-[90%] w-full grow flex-col items-center justify-center p-4">
      <div>
        <img src={'/hållkoll.png'} alt="HållKoll Logo" width={500} />
      </div>
      <div className="mt-8 max-w-[500px] text-center">
        <p>{message}</p>
      </div>
      <div className="flex gap-4 pt-8">
        {onRetry && (
          <SplashAction
            icon={<IconRefresh />}
            onClick={onRetry}
            label={
              <FormattedMessage id="splash.reload" defaultMessage="Reload" />
            }
          />
        )}
        {onSwitchProfile && (
          <SplashAction
            icon={<IconRefresh />}
            onClick={onSwitchProfile}
            label={
              <FormattedMessage
                id="splash.switch_profile"
                defaultMessage="Switch profile"
              />
            }
          />
        )}
        <SplashAction
          icon={<IconLogout />}
          onClick={performLogout}
          label={
            <FormattedMessage id="splash.logout" defaultMessage="Logout" />
          }
        />
      </div>
    </div>
  );
};

export default SplashMessage;
